import React, { useState, useEffect } from 'react';
import BeefBracketVoteTallyVoteCount from './BeefBracketVoteTallyVoteCount';

export default function BeefBracketVoteTallyScore({
  view,
  scoreObject,
  setScoreObject,
  isLoading,
  winningContender,
  useSmallFont,
  championshipView
}) {
  return (
    <div
      className={`beef-bracket-vote-tally-score ${view} ${
        championshipView ? 'championship-view' : ''
      }`}
    >
      <div className="beef-bracket-vote-tally-score-card">
        {championshipView && <span className="championship-ribbon"></span>}
        <div
          className="beef-bracket-vote-tally-score-image"
          style={{ backgroundImage: `url(${scoreObject.image})` }}
        >
          <img src={scoreObject.image} alt={scoreObject.title} />
        </div>
        <div className="beef-bracket-vote-tally-score-title">
          {championshipView && (
            <p className="beef-bracket-vote-champion-text">CHAMPION</p>
          )}
          <h4>{scoreObject.title}</h4>
        </div>
      </div>
      {!championshipView && (
        <div className="beef-bracket-vote-tally-score-votes">
          <BeefBracketVoteTallyVoteCount
            isLoading={isLoading}
            view={view}
            winningContender={winningContender}
            scoreObject={scoreObject}
            setScoreObject={setScoreObject}
            useSmallFont={useSmallFont}
          />
        </div>
      )}
    </div>
  );
}
